import React, {Component} from 'react';
import './CardComponent.css';
import {Link} from 'react-router-dom';

const CardComponent = (
    {
        dateSent,
        recipients,
        profilePic,
        headerImage,
        picture,
        name,
        message,
        firstInitial,
        branchLink,
        secondInitial}) => {
    const bubbleStyle = {
        backgroundImage: profilePic
    };

    console.log("recipients", recipients);

    recipients.sort(function(a, b){
        if(a.profilePic != null) {
            if(b.profilePic != null) {
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            }
            return -1;
        }
        else if(b.profilePic != null) {
            return 1;
        }
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });

    console.log("recipients2", recipients);

    return (
        <div>
            <div className="header-bubble" style={bubbleStyle}>
                {profilePic ? <img src={profilePic} width={100}/> :
                    <p className="initial-text">{firstInitial + secondInitial}</p>}
            </div>
            <div className="card-container">
                <div className="header-image-container">
                    <img className="header-image" src={headerImage}/>
                </div>
                <div className="name-text">{name}</div>
                <div className="sub-name-text">is thankful for</div>
                <img className="thanks-picture" src={picture}/>
                <div className="thanks-to">
                    <div className="recipients">
                        {recipients.map((recipient, i) => {
                            return ( i < 3 ? <span key={"recipient-" + i} className="recipient-avatar"
                                      style={{
                                          backgroundColor: recipient.avatarColor || "#aEaEaE",
                                          zIndex: 10 - i,
                                          left: (6 * i) + "px"
                                      }}>
                                {recipient.profilePic ?
                                      <img src={recipient.profilePic} width={50}/> :
                                      <span className="recipient-initial-text">
                                          {recipient.firstInitial}{recipient.secondInitial}
                                      </span>
                                }
                            </span> : "" )
                        })}
                        <span className="recipient-names">
                        {recipients.map((recipient, i) =>
                            <span key={"recipientName" + i} className="recipient-name">
                                {recipient.name}{ i === recipients.length - 1 ? "": i === recipients.length - 2 ? " & " : ", " }
                            </span>
                        )}
                        </span>
                        <p className="date-sent">{dateSent}</p>
                        {recipients.length > 0 ? <p className="thanks-to-label">Thanks To</p> : "" }
                    </div>
                </div>
                <div className="message-text-container">
                    <p className="message-text">{message}</p>
                </div>
            </div>
        </div>
    )
}

export default CardComponent;


// WEBPACK FOOTER //
// ./src/components/CardComponent/CardComponent.js